import { str, date, FieldMap } from '../acordFieldEngine';

const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'] as const;

export const POLICY_MAP: FieldMap = {
  policyNumber:   str('Policy_PolicyNumberIdentifier_A'),
  effectiveDate:  date('Policy_EffectiveDate_A'),
  expirationDate: date('Policy_ExpirationDate_A'),
};

// Previous approach: map all 10 rows (A–J) from the API
// export const COVERAGE_ROW_MAPS: FieldMap[] = LETTERS.map(l => ({
//   coveragePerilsForms: str(`EvidenceOfProperty_CoverageDescription_${l}`),
//   amountOfInsurance:   str(`EvidenceOfProperty_LimitAmount_${l}`),
//   deductible:          str(`EvidenceOfProperty_DeductibleAmount_${l}`),
// }));

// BIE-match approach: only pre-fill Building (A) and Business Personal Property/Contents (B)
export const COVERAGE_ROW_MAPS: FieldMap[] = (['A', 'B'] as const).map(l => ({
  coveragePerilsForms: str(`EvidenceOfProperty_CoverageDescription_${l}`),
  amountOfInsurance:   str(`EvidenceOfProperty_LimitAmount_${l}`),
  deductible:          str(`EvidenceOfProperty_DeductibleAmount_${l}`),
}));
